import {
  ActivatedRouteSnapshot,
  BaseRouteReuseStrategy,
  Router,
} from '@angular/router';
import { ToastService } from '../../../shared/services/toast.service';

export class PageRefreshRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    current: ActivatedRouteSnapshot,
  ): boolean {
    if (future.routeConfig?.data?.['refreshOnNavigation']) {
      return false;
    }

    return super.shouldReuseRoute(future, current);
  }
}

export async function navigateToRegisteredRoute(
  router: Router,
  toastService: ToastService,
  path: string,
  label: string,
): Promise<void> {
  const routePath = path.replace(/^\/+/, '');
  const isRegistered = router.config.some(
    (route) =>
      route.path === routePath ||
      route.children?.some((child) => child.path === routePath),
  );

  if (!isRegistered) {
    reportUnavailable(toastService, label);
    return;
  }

  try {
    const navigated =
      router.url === path
        ? await router.navigateByUrl(path, { onSameUrlNavigation: 'reload' })
        : await router.navigateByUrl(path);

    if (navigated) {
      return;
    }
  } catch {
    reportUnavailable(toastService, label);
    return;
  }

  reportUnavailable(toastService, label);
}

function reportUnavailable(toastService: ToastService, label: string): void {
  toastService.show(
    `${label} is not available yet. Please try again later.`,
    { duration: 5000 },
  );
}
